import ProductCard from "segments/desktop/core-components/product-card/product-card";
import { StyledProductCardsSideBySideTextAndAssetComponent } from "./product-cards-side-by-side-text-and-asset-component.scss";

const ProductCardsSideBySideTextAndAssetComponent = ({ cards }) => (
  <StyledProductCardsSideBySideTextAndAssetComponent className="product-cards-side-by-side-text-and-asset-component">
    {cards?.map((card) => (
      <ProductCard isCondensed={cards.length > 1} {...card} />
    ))}
  </StyledProductCardsSideBySideTextAndAssetComponent>
);

export default ProductCardsSideBySideTextAndAssetComponent;
